import styled, { css } from 'styled-components';
export const FieldContainer = styled.div `
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
`;
export const FieldTitle = styled.label `
  ${({ theme }) => theme.getFontStyle('samsung-700-12')};
  ${({ theme }) => theme.getColor('black')};
  ${({ required }) => {
    if (required) {
        return css `
        &:after {
          content: '*';
          color: ${({ theme }) => theme.getColor('error', 'default')};
          margin-left: 0.2rem;
        }
      `;
    }
}};
  margin-bottom: 0.4rem;
`;
export const FieldError = styled.div `
  display: flex;
  align-items: center;
  column-gap: 0.4rem;
  height: 1.4rem;
  margin-top: 0.2rem;
`;
export const FieldErrorMessage = styled.span `
  ${({ theme }) => theme.getFontStyle('samsung-400-12')};
  color: ${({ theme }) => theme.getColor('error', 'default')};
`;
//# sourceMappingURL=FieldWrapper.styles.js.map